.container {
  align-items: center;
  flex: 1;
}

.tunerRow {
  min-height: 50px;
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.progressUnder {
  flex: 1;
  transform: scaleX(-1);
}

.progressOver {
  flex: 1;
}

.avatar {
  color: var(--tuna-content-onColor);
}
